<!-- MODAL HEADER -->
<div class="modal-header">
  <h3 class="modal-title"><strong>{{ isEditMode ? 'Edit Config' : 'Add Config' }}</strong></h3>
  <div class="header-actions">
    <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- MODAL BODY -->
<form class="form-horizontal" [hidden]="minimise" novalidate>
<div class="modal-body no-body-scroll">

  @if (loadingData) {
<div class="modal-loading">
    <i class="fa fa-spinner fa-spin fa-3x"></i>
  </div>
}

  @if (!loadingData) {
<div class="form-row-grid">
    <div class="form-cell form-cell--tax-year">
      <label class="control-label">Tax Year</label>
      <div class="form-value"><strong>{{ filterTaxYear }}</strong></div>
    </div>

    @if (showGeneralBranchContext) {
<div class="form-cell">
      <label for="genBranchBasketSelect">Basket</label>
      <select id="genBranchBasketSelect" class="form-control input-sm"
              name="generalBranchBasket"
              [(ngModel)]="selectedGeneralBranchBasket"
              (ngModelChange)="onGeneralBranchBasketChange($event)"
              required>
        <option value="">Select</option>
        @for (s of generalBranchBasketData; track $index) {
<option [value]="s.CODE_KEY">
          {{ s.CODE_DESCRIPTION || s.CODE_DISP_DESC }}
        </option>
}
      </select>
    </div>
}

    @if (!showGeneralBranchContext) {
<div class="form-cell">
      <label for="basketSelect">Basket</label>
      <select id="basketSelect" class="form-control input-sm"
              name="sourceCodes-typ"
              [(ngModel)]="selectedSourceCode"
              (ngModelChange)="onBasketChange($event)"
              [disabled]="isEditMode"
              required>
        <option value="">Select</option>
        @for (s of sourceData; track $index) {
<option [value]="s.CODE_KEY">
          {{ s.CODE_DESCRIPTION }}
        </option>
}
      </select>
    </div>
}

    @for (t of savedData; track $index; let i = $index) {
<div class="form-cell">
      <label class="control-label" [attr.for]="'configPct' + i">{{ getConfigLineLabel(t) }}</label>
      <input type="number"
             [id]="'configPct' + i"
             class="form-control input-sm"
             [(ngModel)]="t.CONFIG_PERCENTAGE"
             [ngModelOptions]="{standalone: true}"
             (keypress)="onKeyPress($event)">
    </div>
}
  </div>
}

</div>
</form>

<!-- MODAL FOOTER -->
<div class="modal-footer" [hidden]="minimise">
  <button class="btn btn-info btn-sm" type="button"
          [disabled]="isSaveClicked" (click)="save()" style="margin-right: 5px;">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
  </button>
  <button class="btn btn-default btn-sm" type="button" (click)="reset()" style="margin-right: 5px;">
    Reset
  </button>
  <button class="btn btn-warning btn-sm" type="button" (click)="cancel()">
    Cancel
  </button>
</div>
